import React, {createContext} from "react";
import styled from "styled-components";
import normaliseResponsiveProp from "../../utils/normaliseResponsiveProp";
import mediaQueries from "../../utils/mediaQueries";
import mapResponsiveProp, {mapResponsivePropAndInverse} from "../../utils/mapResponsiveProp";
import spaceMap from "../../utils/spaceMap";
import responsiveRangeProps from "../Hidden/responsiveRangeProps";
import verticalAlignMap from "../../utils/verticalAlignMap";
import alignMap from "../../utils/alignMap";

const overwriteMarginTopMap = {
    flex: 0,
    block: undefined,
};

const ColumnsOuter = styled.div`
    display: flex;
    height: 100%;
    ${({display, verticalAlign, align, space}) =>
        mediaQueries({
            marginTop: mapResponsivePropAndInverse(space, spaceMap),
            marginLeft: mapResponsivePropAndInverse(space, spaceMap),
            display,
            justifyContent: mapResponsiveProp(align, alignMap),
            alignItems: mapResponsiveProp(verticalAlign, verticalAlignMap),
        })};
    ${({display}) =>
        mediaQueries({
            marginTop: mapResponsiveProp(display, overwriteMarginTopMap),
        })};
`;

export const ColumnsContext = createContext({
    space: "none",
    collapseMobile: false,
    collapseTablet: false,
    collapseDesktop: false,
    mobileSpace: "none",
    tabletSpace: "none",
    desktopSpace: "none",
});

export default function Columns({children, collapseBelow, space = "none", align, verticalAlign}) {
    const [collapseMobile, collapseTablet, collapseDesktop] = responsiveRangeProps({
        below: collapseBelow,
    });
    const [mobileSpace, tabletSpace, desktopSpace] = normaliseResponsiveProp(space);

    const display = [
        collapseMobile ? "block" : "flex",
        collapseTablet ? "block" : "flex",
        collapseDesktop ? "block" : "flex",
        "flex",
    ];

    return (
        <ColumnsContext.Provider
            value={{
                collapseMobile,
                collapseTablet,
                collapseDesktop,
                mobileSpace,
                tabletSpace,
                desktopSpace,
            }}
        >
            <ColumnsOuter
                data-test-id="columns"
                space={space}
                display={display}
                align={align}
                verticalAlign={verticalAlign}
            >
                {children}
            </ColumnsOuter>
        </ColumnsContext.Provider>
    );
}
